<button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" (click)="focusInput()">
  <ng-container *ngIf="supplier">
    {{ supplier.name }}
  </ng-container>
  <ng-container *ngIf="supplier == undefined">
    Sélectionner
  </ng-container>
</button>
<div class="dropdown-menu p-3">
  <input #input type="text" class="form-control" placeholder="Recherche" [(ngModel)]="searchRequest.name" (keyup)="search()" autofocus/>
  <div role="separator" class="dropdown-divider"></div>
  <div class="text-center" *ngIf="results == undefined || results.content.length == 0">Aucun fournisseur trouvé</div>
  <div class="results" *ngIf="results">
    <a class="dropdown-item" *ngFor="let result of results.content" (click)="select(result)">{{ result.name }}</a>
  </div>
  <div class="text-center border-top pt-2" *ngIf="results != undefined &amp;&amp; results.content.length != 0">
    {{ results.numberOfElements }} fournisseur(s) affiché(s) sur {{ results.totalElements }} résultat(s)
  </div>
</div>